import * as React from "react";

import "./dnm-card.scss";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {UseState}       from "@Common/react/use-state";
import {ConfirmDialog}  from "@Common/ui-components/heavy/common/design2/dialogs/confirm-dialog/confirm-dialog";

export const dnmCard = ({item, officeId, dnmList}) => cs(
    consumeContext("apis"),
    consumeContext("session"),
    ["confirmDialog", ({}, next) => ConfirmDialog({next})],
    ["removing", (_, next) => UseState({initValue: false, next})],
    ({apis, session, confirmDialog, removing}) => (
        <div className="dnm-card-f7n0" xd-qa-type="card" xd-qa-name={item.address}>
            <div className="card-left">
                <div className="street" xd-qa-type="label" xd-qa-name="Street">{item.address}</div>
                <div className="links2">
                    <div className="link-group">
                        <div className="label" xd-qa-type="label" xd-qa-name="City">City</div>
                        <div className="value" xd-qa-type="text" xd-qa-name="City">{item.city}</div>
                    </div>

                    <div className="link-group">
                        <div className="label" xd-qa-type="label" xd-qa-name="State">State</div>
                        <div className="value" xd-qa-type="text" xd-qa-name="State">{item.state}</div>
                    </div>

                    <div className="link-group">
                        <div className="label" xd-qa-type="label" xd-qa-name="Zip">Zip</div>
                        <div className="value" xd-qa-type="text" xd-qa-name="Zip">{item.zip}</div>
                    </div>
                </div>
            </div>

            <div className="card-right">
                <div
                    className="top"
                    xd-qa-type={removing.value ? "label" : "icon"}
                    xd-qa-name={removing.value ? "Deleting..." : "Trash"}
                >
                    {removing.value ? (
                        "Deleting..."
                    ) : (
                        <img
                            className={removing.value ? "trash-can disabled" : "trash-can"}
                            src={require("../../../../../../../../public/assets/trash2.svg")}
                            alt="Delete"
                            onClick={ async () => {
                                if(await confirmDialog.show({
                                    actionName: "Delete",
                                    message: <span>This address will be deleted<br/><br/>
                                    {item.address}<br/>
                                    {item.city}, {item.state} {item.zip}
                                    </span>
                                })) {
                                    removing.onChange(true);
                                    await apis.next.mailing.dnm.deleteDoNotMailAddress(item.idPrimary, officeId);
                                    dnmList.onChange(dnmList.value.filter(id => id.idPrimary != item.idPrimary));
                                    removing.onChange(false);
                                }

                            }
                        }/>
                    )}
                </div>
            </div>
        </div>
    ),
);
